import {
  Box,
  Button,
  Checkbox,
  Flex,
  Group,
  Stack,
  Table,
  Text,
  TextInput,
  Textarea,
  ThemeIcon,
  Title,
  Tooltip,
} from '@mantine/core'
import { IconInfoCircleFilled } from '@tabler/icons-react'
import classes from './AdminSettings.module.css'

const MOCK_DATA = Array(5).fill({
  value: 'value',
  hidden: false,
  modifiedBy: 'Alfredo Carrillo',
  modifiedOn: (
    <Stack gap={0}>
      <Text size="xs">5:59pm</Text>
      <Text size="xs" c="dimmed">
        Mar 11
      </Text>
    </Stack>
  ),
})

export const CustomFieldsControlRecordVisibility = () => {
  return (
    <>
      <Box p="md">
        <Title order={6}>
          Display this field on the following record types:{' '}
          <Text c="red" span>
            *
          </Text>
        </Title>
        <Stack gap="xs" mt="md">
          <Checkbox label="Contact and Record Person" />
          <Checkbox label="Child" />
          <Checkbox label="Staff" />
          <Checkbox label="Partner (community partner staff records)" />
          <Checkbox label="Community partner (place records)" />
          <Checkbox label="Hide this question and retain field data." />
        </Stack>
      </Box>
      <Flex p="md" mt="lg" justify="flex-start" gap="xs">
        <Button size="md" variant="default">
          Cancel
        </Button>
        <Button size="md">Next</Button>
      </Flex>
    </>
  )
}
